import type { DepositStatusResponseDto } from '@/lib/models/depositStatusResponseDto';
import { DepositStatusResponseDtoStatus } from '@/lib/models/depositStatusResponseDtoStatus';
import successIcon from '@/assets/v.svg';

interface Props {
  result: DepositStatusResponseDto;
}

/**
 * Bottom-sheet content shown after a deposit clears (or settles into
 * `processing`). Per design there are no CTAs — the user dismisses the sheet
 * to return to the wallet.
 */
export function DepositSuccess({ result }: Props) {
  const isProcessing = result.status === DepositStatusResponseDtoStatus.PROCESSING;

  return (
    <div className="flex flex-col items-center text-center" role="status" aria-live="polite">
      <h2 className="text-[34.2px] font-semibold leading-normal text-ink">{isProcessing ? 'Almost there' : 'Success!'}</h2>
      <p className="mt-3.5 max-w-[377px] text-[21.6px] leading-[34px] text-ink">
        {isProcessing
          ? 'Your bank is finalising the payment. Your wallet will update shortly.'
          : 'Your purchase was successful!'}
      </p>
      <img src={successIcon} alt="" aria-hidden className="my-6 size-[140px] motion-safe:animate-deposit-pop" />
    </div>
  );
}
